module.exports = __webpack_public_path__ + "img/hekpImage.733092e5.png";